import axios from 'axios';
import store from '../store';
export default {
  namespaced: true,
  
  state: {
    idmodal: '',
    descripcionmodal: '',
    banderamodal: null,
    tallas:[],
    talla:[]

    
    
  },
  mutations: {

    LoadProductos(state,buscar) {
      //let aux = [];
      state.talla = state.tallas;

      let aux = state.tallas.filter((x) => x["nombretalla"].toUpperCase().includes(buscar.toUpperCase()),);
      if (buscar == "") {
        state.talla = state.tallas;
      } else {
        state.talla = aux;
     
      }
    },



    async  cargardatostalla(state){
      
      state.tallas = []
      var token = store.state.numero;
    

      await axios
      .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/tallas", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        state.tallas = response.data.data;
        
      });
      state.talla = state.tallas
    },
    
    cambio(state,descripcion){
     state.descripcionmodal =descripcion
  
    },
    agregartable(state)  {
      
      //      this.descripcionmodal = descripcion
      var token = store.state.numero;
      var datos = {
        nombretalla: state.descripcionmodal
      };
      this.banderamodal = store.state.banderamodal
      
    
      
      var datosfalso = state.idmodal;
    
      if (this.banderamodal === true) {
        
        
        axios
        
        .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/tallas", datos, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          this.token = tokenn;
      
          
        })
        
        .catch((e) => {
          console.log(e);
        });
      } else {
        
        axios
        
        .post(
          "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/tallas/UpdateReg/" +
          datosfalso,
          datos,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
          )
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;
         
          })
          
          .catch((e) => {
            console.log(e);
          });
        }
        
      },
      
      
      datosmodal(state, api) {
   
        state.idmodal = api.idtalla,
        state.descripcionmodal = api.nombretalla
        
      },
      
      
      
      async  eliminar(state, api) {
        var token = store.state.numero
        let eliminar = api;
     
        await axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/tallas/DeleteReg/" + eliminar,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        
        
        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          state.eliminer = tokenn;
        
          //this.bandera = true;
        })
        
        .catch((e) => {
          console.log(e);
        });
        
        
        
      },
      
      
      
    },
    actions: {
      
    },
    getters: {
      
      
    },
    
    
    



}